export const jobType = {
  NOTIFICATION : 'notification'
}

export const jobStatus = {
  WAITING : 'waiting_to_trigger',
  TRIGGERED:  'triggered'
}
